import axios from 'axios';
import { ALL } from '../constants';
import { LeasePriceAPIParams } from './../actions/leasePricing';
import { format } from 'date-fns';
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
  'Content-Type': 'application/json',
};

const BASE_URL = (process.env.REACT_APP_API_BASE_PATH || '') + '/leasemax';
const SCHEDULER_API_PATH = BASE_URL + '/scheduler';

const MAX_RETRIES = 3; // Maximum number of retries
const RETRY_DELAY = 500; // Delay in milliseconds between retries

const fetchWithRetry = async (
  url: string,
  options = {},
  retries = MAX_RETRIES
) => {
  try {
    return await axios.get(url, options);
  } catch (error: any) {
    if (!error.response?.data && error.request && retries > 0) {
      // The request was made but no response was received
      console.log(
        `CORS or Network error encountered. Retrying... (${
          MAX_RETRIES - retries + 1
        })`
      );

      await new Promise((res) => setTimeout(res, RETRY_DELAY)); // Wait before retrying
      return fetchWithRetry(url, options, retries - 1);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      throw error;
    }
  }
};

const GET_DASHBOARD_DATA = BASE_URL + '/getDashboardData';
const GET_KPI_DATA = BASE_URL + '/getKPIData';
const GET_RENEWAL_OFFERS = BASE_URL + '/getRenewalOffers';
const LOGIN_URL = BASE_URL + '/userSignIn';
const LOGOUT_URL = BASE_URL + '/logout';
const SWITCH_CLIENT_URL = BASE_URL + '/switchClient';
const GET_LINKED_CLIENTS_URL = BASE_URL + '/getLinkedClients';
const GET_CURRENT_CLIENT_URL = BASE_URL + '/getCurrentClient';
const EMAIL_LOGIN_LINK_URL = BASE_URL + '/emailLoginLink';
const MAGIC_LINK_SIGNIN_URL = BASE_URL + '/magicLinkSignIn';
const RESET_PASSWORD_URL = BASE_URL + '/resetPassword';
const FORGOT_PASSWORD_URL = BASE_URL + '/forgotPassword';
const UPDATE_OFFER_URL = BASE_URL + '/updateOffer';
const SHIFT_OFFERS_URL = BASE_URL + '/shiftOffers';
const ADD_CHARGE_URL = BASE_URL + '/addCharge';
const ADD_OFFER_URL = BASE_URL + '/addOffer';
const GET_CHARGE_CODES_URL = BASE_URL + '/getChargeCodes';
const REMOVE_CHARGE_URL = BASE_URL + '/removeCharge';
const REMOVE_OFFER_URL = BASE_URL + '/removeOffer';
const SEARCH_TENANT_URL = BASE_URL + '/searchTenant';
const APPROVE_OFFER_URL = BASE_URL + '/approveOffer';
const DISAPPROVE_OFFER_URL = BASE_URL + '/disApproveOffer';
const TOGGLE_APPROVE_ALL_URL = BASE_URL + '/toggleApproveAll';
const VALIDATE_TOKEN_URL = BASE_URL + '/validateToken';
const TOGGLE_EXCLUDE_OFFERS = BASE_URL + '/toggleExcludeOffers';
const VALIDATE_AUTH_CODE_URL = BASE_URL + '/validateAuthCode';

// ENTRATA OAuth
const ENTRATA_SIGNUP_URL = BASE_URL + '/signUpEntrataUser';

// Flag API's
const FLAG_ITEM = BASE_URL + '/flagItem';
const RESOLVE_FLAG = BASE_URL + '/resolveFlag';
const FETCH_FLAG_COMMENTS = BASE_URL + '/fetchFlagComments';
const ADD_COMMENT = BASE_URL + '/addFlagComments';
// Flag API's

const GET_OFFERS_CYCLES = BASE_URL + '/getOfferCycles';
const GET_EXEC_DOWNLOAD_URL = BASE_URL + '/getSignedUrl';
const GET_OVERRIDE_REPORT_DATA = BASE_URL + '/getLoggedData';
const GET_PREV_OFFER_DATA_URL = BASE_URL + '/getPreviousGeneratedOffers';
const UPDATE_CHARGE_URL = BASE_URL + '/updateCharge';
const GET_LEM_DATA_URL = BASE_URL + '/getLEMData';
const GET_MARKET_STRENGTH_DATA = BASE_URL + '/getMarketStrength';
const GET_CHARGE_MARKET_RENT = BASE_URL + '/getChargeMarketRent';
const GET_MANAGED_PROPERTIES = BASE_URL + '/getManagedPropertyDetails';
const GET_RENEWAL_DASHBOARD_DATA = BASE_URL + '/getRenewalDashboardData';
const GET_PROPERTY_PORTFOLIO_DATA =
  BASE_URL + '/property-portfolio/getPropertyData';

// Lease Price API's
const GET_UNIT_TYPES = BASE_URL + '/getUnitTypes';
const GET_UNIT_TYPE_DETAILS = BASE_URL + '/unitTypeDetails';
const GET_PRICE_MATRICES = BASE_URL + '/getPriceMatrices';
const ADJUST_PRICE = BASE_URL + '/adjustPrice';
const LEASE_PRICE_APPROVE_URL = BASE_URL + '/approvePrice';
const LEASE_PRICE_EXCLUDE_URL = BASE_URL + '/excludePrice';
// Lease Price Api's

const GET_OFFER_COMPILANCE = BASE_URL + '/reports/1';
const GET_RENEWAL_FORECAST = BASE_URL + '/reports/2';
const GET_ACTIVE_REPORTS = BASE_URL + '/reports';
const GET_NO_WALK_SCORES = BASE_URL + '/getNoWalkScores';
const UPDATE_USER_EXPECTED_RENEWALS = BASE_URL + '/updateUserExpectedRenewal';
const GET_USER_EXPECTED_RENEWALS = BASE_URL + '/getUserExpectedRenwal';
const RENEWAL_SUMMARY = BASE_URL + '/getRenewalsSummary';
const VALIDATE_AUTH_TOKEN_URL = BASE_URL + '/validateAuthToken';

const LEASE_SUMMARY = BASE_URL + '/leasePriceSummary';
// Strategy API

const SETTINGS_SUMMARY = BASE_URL + '/settings/strategySummary';
const SETTINGS = BASE_URL + '/strategies';
const UPDATE_SETTINGS = BASE_URL + '/strategies';
const UPDATE_STRATEGY_BY_MARKET_URL = BASE_URL + '/updateStrategyByMarket';
//MASTER SETTINGS
const MASTER_SETTINGS = BASE_URL + '/settings';
const PROPERTIES_SETTINGS = BASE_URL + '/settings/properties';
const GET_SETTING = BASE_URL + '/setting';

//SFR Lease pricing
const GET_SFR_PROPERTIES_URL = BASE_URL + '/getSfrProperties';
const SFR_NEW_LEASE_OFFERS_URL = BASE_URL + '/getSfrOffers';
const OCCUPANCY_REPORT = BASE_URL + '/new-reports/occupancy';

//USER
const GET_USERS = BASE_URL + '/user';

// new reports
const GET_LEASE_REPORT_DATA = BASE_URL + '/new-reports/lease';
const GET_RENEWAL_REPORT_DATA = BASE_URL + '/new-reports/renewal';
const GET_GENERAL_REPORT_DATA = BASE_URL + '/new-reports/general';

const DOWNLOADS = BASE_URL + '/exports';

//Scheduler
const SCHEDULER_REQUEST = BASE_URL + '/userReportRequest';
const GET_SCHEDULED_JOBS_URL = `${SCHEDULER_API_PATH}/jobs/executionLogs`;
const GET_TASK_EXECUTION_STATUS_URL = (id: string) =>
  `${SCHEDULER_API_PATH}/scheduledTasks/execution/${id}/status`;
const CHECK_MARKET_RENT_OFFER_GENERATION_STATUS = `${SCHEDULER_API_PATH}/scheduledTasks/offers/status`;
// Unit level pricing
const GET_UNIT_DETAILS = BASE_URL + '/lease-pricing/unit/details';
const GET_UNIT_PRICE_MATRIX = BASE_URL + '/lease-pricing/unit/price-matrix';
const EXCLUDE_UNIT_PRICE_URL = BASE_URL + '/lease-pricing/unit/exclude';
const APPROVE_UNIT_PRICE_URL = BASE_URL + '/lease-pricing/unit/approve';
const UPDATE_UNIT_OFFERS = BASE_URL + '/lease-pricing/unit/offers';

const SETTINGS_STRATEGY_SPECS = BASE_URL + '/strategySpecs';

const EXPOSURE_RENT_TREND_REPORT = BASE_URL + '/reportsv2';

const GET_TASK_EXECUTION_STATUS = BASE_URL + '/taskExecutionStatus';

const SHIFT_PRICE_MATRICES = BASE_URL + '/lease-pricing/unit-type/offers';

const UPLOAD_TO_PMS_URL = BASE_URL + '/offers/';

// Generate Offers
const GENERATE_RENEWAL_OFFERS = BASE_URL + '/offers/renewal/generate';
const GENERATE_NEW_LEASE_OFFERS = BASE_URL + '/offers/newLease/generate';

const GET_MARKET_RENT_REPORTS = BASE_URL + '/settings/marketRent';
const UPDATE_MARKET_RENT_REPORTS = BASE_URL + '/settings/marketRent';

// bulk approve
const BULK_APPROVE_RENEWALS = BASE_URL + '/renewals/bulkApprove';
const BULK_APPROVE_UNITTYPE_OFFERS =
  BASE_URL + '/newLease/unitType/bulkApprove';
const BULK_APPROVE_UNITLEVEL_OFFERS = BASE_URL + '/newLease/unit/bulkApprove';

// upload offer logs
const GET_RENEWAL_UPLOAD_OFFER_LOGS = BASE_URL + '/renewal/uploadOfferLogs';
const GET_NEW_LEASE_UPLOAD_OFFER_LOGS = BASE_URL + '/newLease/uploadOfferLogs';

// Unified Lease Pricing
const GET_FILTER_OPTIONS = BASE_URL + '/lease-pricing/unified/getFilterOptions';
const GET_FLOORPLAN_DATA = BASE_URL + '/lease-pricing/unified/getFloorplanData';
const GET_UNITS_DATA = BASE_URL + '/lease-pricing/unified/getUnitsData';
const GET_STATS_DATA = BASE_URL + '/lease-pricing/unified/getStatsData';
const GET_PRICE_MATRICES_UNIFIED =
  BASE_URL + '/lease-pricing/unified/getPriceMatrices';
const UNIFIED_APPROVE_OFFER_URL =
  BASE_URL + '/lease-pricing/unified/approveOffer';
const UNIFIED_EXCLUDE_OFFER_URL =
  BASE_URL + '/lease-pricing/unified/excludeOffer';
const GET_FLAG_DETAILS_URL = BASE_URL + '/lease-pricing/unified/getFlagDetails';
const ADD_FLAG_COMMENT_URL = BASE_URL + '/lease-pricing/unified/addFlagComment';
const RESOLVE_FLAG_ITEM_URL = BASE_URL + '/lease-pricing/unified/resolveFlag';
const SHIFT_ALL_OFFERS_URL = BASE_URL + '/lease-pricing/unified/shiftAllOffers';
const APPROVE_ALL_URL = BASE_URL + '/lease-pricing/unified/approveAll';

const getReportParams = (data: any) => {
  const params = new URLSearchParams();

  if (data.offerCycle) {
    params.append('offerCycle', data.offerCycle);
  }
  if (data.propertyCode) {
    params.append('propertyCode', data.propertyCode);
  }
  if (data.length) {
    params.append('length', data.length);
  }

  if (data.market) {
    params.append('market', data.market);
  }

  if (data.ReportType) {
    params.append('reportType', data.ReportType);
  }
  return params;
};

const api = {
  login: (credentials: any) => {
    return axios.post(LOGIN_URL, credentials);
  },
  logout: () => {
    return fetchWithRetry(LOGOUT_URL);
  },
  switchClient: (selectedClientId: number) => {
    return axios.post(SWITCH_CLIENT_URL, { clientId: selectedClientId });
  },
  getLinkedClients: () => {
    return fetchWithRetry(GET_LINKED_CLIENTS_URL);
  },
  getCurrentClient: () => {
    return fetchWithRetry(GET_CURRENT_CLIENT_URL);
  },
  emailLoginLink: (email: string) => {
    return axios.post(EMAIL_LOGIN_LINK_URL, { email });
  },
  magicLinkSignIn: (token: string) => {
    return axios.post(MAGIC_LINK_SIGNIN_URL, { token });
  },
  getDashboardData: (monthPart: any) => {
    return axios.post(GET_DASHBOARD_DATA, { drange: monthPart });
  },
  getKPIData: () => {
    return axios.post(GET_KPI_DATA, {});
  },
  getRenewalOffers: (tenant_id: any) => {
    return axios.post(GET_RENEWAL_OFFERS, { tenant_id });
  },
  updateOffer: (data: any) => {
    return axios.post(UPDATE_OFFER_URL, data);
  },
  shiftOffers: (data: any) => {
    return axios.post(SHIFT_OFFERS_URL, data);
  },
  addCharge: (data: any) => {
    return axios.post(ADD_CHARGE_URL, data);
  },
  removeCharge: (data: any) => {
    return axios.post(REMOVE_CHARGE_URL, data);
  },
  searchTenant: (tenant_code: any) => {
    return axios.post(SEARCH_TENANT_URL, { tenant_code });
  },
  addOffer: (data: any) => {
    return axios.post(ADD_OFFER_URL, data);
  },
  getCharges: () => {
    return fetchWithRetry(GET_CHARGE_CODES_URL);
  },
  approveOffer: (data: any) => {
    return axios.post(APPROVE_OFFER_URL, data);
  },
  disApproveOffer: (data: any) => {
    return axios.post(DISAPPROVE_OFFER_URL, data);
  },
  toggleApproveAll: (data: any) => {
    return axios.post(TOGGLE_APPROVE_ALL_URL, data);
  },
  resetPassword: (data: any) => {
    return axios.post(RESET_PASSWORD_URL, data);
  },
  forgotPassword: (data: any) => {
    return axios.post(FORGOT_PASSWORD_URL, data);
  },
  validateToken: (token: any) => {
    return axios.post(VALIDATE_TOKEN_URL, { token });
  },
  toggleExcludeOffers: (data: any) => {
    return axios.post(TOGGLE_EXCLUDE_OFFERS, data);
  },

  // Flag Api's
  flagItem: (data: any) => {
    return axios.post(FLAG_ITEM, data);
  },
  resolveFlag: (data: any) => {
    return axios.post(RESOLVE_FLAG, data);
  },
  fetchComments: (data: any) => {
    return axios.post(FETCH_FLAG_COMMENTS, data);
  },
  addComment: (data: any) => {
    return axios.post(ADD_COMMENT, data);
  },
  // Flag Api's

  getOfferCycles: (type: string = 'Renewal') => {
    const params = new URLSearchParams();
    params.append('type', type);

    return fetchWithRetry(`${GET_OFFERS_CYCLES}?${params.toString()}`);
  },
  getOfferCompilance: () => {
    return axios.post(GET_OFFER_COMPILANCE, {}); //
  },
  getRenewalForecast: () => {
    return axios.post(GET_RENEWAL_FORECAST, {});
  },
  getAllReports: () => {
    return fetchWithRetry(GET_ACTIVE_REPORTS);
  },
  getReport: (id: number, filters: string[]) => {
    let url = GET_ACTIVE_REPORTS + '/' + id;
    if (filters.length > 0) {
      url = url + '?' + filters.join('&');
    }

    return fetchWithRetry(url);
  },

  getExecDownloadUrl: (data: any) => {
    return axios.post(GET_EXEC_DOWNLOAD_URL, data);
  },
  getOverrideReportData: (offer_cycle: any) => {
    return axios.post(GET_OVERRIDE_REPORT_DATA, { offer_cycle });
  },
  getPrevOfferData: (offer_cycle: any) => {
    return axios.post(GET_PREV_OFFER_DATA_URL, offer_cycle);
  },
  removeOffer: (offer_id: any) => {
    return axios.post(REMOVE_OFFER_URL, { offer_id });
  },
  updateCharge: (data: any) => {
    return axios.post(UPDATE_CHARGE_URL, data);
  },
  getLemData: (data: any) => {
    return axios.post(GET_LEM_DATA_URL, data);
  },
  getMarketStrength: () => {
    return axios.post(GET_MARKET_STRENGTH_DATA, null);
  },
  getChargeMarketRent: () => {
    return axios.post(GET_CHARGE_MARKET_RENT, null);
  },
  getManagedProperties: () => {
    return fetchWithRetry(GET_MANAGED_PROPERTIES);
  },
  getRenewalDashboardData: (data: any) => {
    return axios.post(GET_RENEWAL_DASHBOARD_DATA, data);
  },

  // Lease Price Api's
  getUnitTypes: () => {
    return fetchWithRetry(GET_UNIT_TYPES);
  },
  getUnitTypeDetails: (params: any): Promise<any> => {
    let urlParams = new URLSearchParams();
    const { beds, propertyCode, unitTypeCode, ...rest } = params;
    if (params.beds && params.beds.toString() !== ALL) {
      rest.beds = beds;
    }
    if (params.propertyCode && params.propertyCode.toString() !== ALL)
      rest.propertyCode = propertyCode;

    if (params.unitTypeCode && params.unitTypeCode.toString() !== ALL)
      rest.unitTypeCode = unitTypeCode;

    Object.entries(rest).forEach(([key, value]) => {
      if (value) urlParams.append(key, value as string);
    });

    return fetchWithRetry(`${GET_UNIT_TYPE_DETAILS}?${urlParams.toString()}`);
  },

  getPriceMatrices: (params: any) => {
    let urlParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) urlParams.append(key, value as string);
    });
    return fetchWithRetry(`${GET_PRICE_MATRICES}?${urlParams.toString()}`);
  },

  adjustLeasePrice: (data: any) => {
    return axios.post(ADJUST_PRICE, data);
  },
  approveLeasePrice: (data: any) => {
    return axios.post(LEASE_PRICE_APPROVE_URL, data);
  },
  excludeLeasePrice: (data: any) => {
    return axios.post(LEASE_PRICE_EXCLUDE_URL, data);
  },
  approveUnitLeasePrice: (data: {
    unitDetailId: number;
    isApproved: boolean;
  }) => {
    return axios.put(APPROVE_UNIT_PRICE_URL, data);
  },
  excludeUnitLeasePrice: (data: {
    unitDetailId: number;
    isExcluded: boolean;
  }) => {
    return axios.put(EXCLUDE_UNIT_PRICE_URL, data);
  },

  // Lease Price Api's
  getNoWalkScores: (data: any) => {
    return axios.post(GET_NO_WALK_SCORES, data);
  },
  getUserExpectedRenewals: () => {
    return fetchWithRetry(GET_USER_EXPECTED_RENEWALS);
  },
  updateUserExpectedRenewals: (data: any) => {
    return axios.post(UPDATE_USER_EXPECTED_RENEWALS, data);
  },
  validateAuthToken: () => {
    return fetchWithRetry(VALIDATE_AUTH_TOKEN_URL);
  },
  getRenewalSummary: (data: any) => {
    return axios.post(RENEWAL_SUMMARY, data);
  },
  getUnitDetails: (params?: LeasePriceAPIParams) => {
    return fetchWithRetry(GET_UNIT_DETAILS);
  },

  getLeaseSummary: (data: any) => {
    const params = new URLSearchParams();
    params.append('startDate', data.startDate);
    params.append('length', data.length);
    if (data.bedRoom !== undefined && String(data.bedRoom) !== ALL) {
      params.append('bedRoom', data.bedRoom);
    }
    data?.propertyCode && params.append('propertyCode', data.propertyCode);
    data?.market && params.append('market', data.market);
    data?.unitType && params.append('unitType', data.unitType);

    let url = `${LEASE_SUMMARY}?${params.toString()}`;

    return fetchWithRetry(url);
  },
  getStrategies: (data: any) => {
    const params = new URLSearchParams();
    params.append('key', 'Renewal.Strategy,NewLease.Strategy');
    if (data.hasOwnProperty('propertyCode')) {
      params.append('propertyCode', data.propertyCode);
    }

    let url = `${SETTINGS_SUMMARY}?${params.toString()}`;

    return fetchWithRetry(url);
  },
  getRulesEngineSettings: (data: any) => {
    const params = new URLSearchParams();

    if (data.hasOwnProperty('propertyCode')) {
      params.append('propertyCode', data.propertyCode);
    }
    let url = `${MASTER_SETTINGS}?${params.toString()}`;
    return fetchWithRetry(url);
  },
  getStrategiesState: (data: any) => {
    const params = new URLSearchParams();
    params.append('type', 'Renewal.Strategy,NewLease.Strategy');
    if (data.hasOwnProperty('propertyCode')) {
      params.append('propertyCode', data.propertyCode);
    }
    let url = `${SETTINGS}?${params.toString()}`;
    return fetchWithRetry(url);
  },
  updateStrategy: (data: any) => {
    return axios.put(UPDATE_SETTINGS, data);
  },
  createStrategy: (data: any) => {
    return axios.put(UPDATE_SETTINGS + '/' + data.id, data);
    //return axios.post(UPDATE_SETTINGS, data);
  },
  updateCustomStrategy: (data: any) => {
    return axios.put(UPDATE_SETTINGS + '/' + data.id, data, getConfig());
  },
  getSFRNewLeaseOffers: (params: any) => {
    let urlParams = new URLSearchParams();
    const { beds, propertyCode, market, unitAvailabilityStatus, ...rest } =
      params;

    if ((params.beds && params.beds !== ALL) || params.beds === 0) {
      rest.beds = beds;
    }
    if (params.propertyCode && params.propertyCode !== ALL)
      rest.propertyCode = propertyCode;
    if (params.market && params.market !== ALL) rest.market = market;
    if (params.unitAvailabilityStatus) {
      rest.unitAvailability =
        params.unitAvailabilityStatus === 'Occupied' ? 'false' : 'true';
    }

    Object.entries(rest).forEach((entry) => {
      if (entry[1]) urlParams.append(entry[0], entry[1] as string);
    });

    let bedsFix = '';
    if (params.hasOwnProperty('beds') && params.beds === 0) {
      bedsFix = '&beds=0';
    }

    return fetchWithRetry(
      `${SFR_NEW_LEASE_OFFERS_URL}?${urlParams.toString()}` + bedsFix
    );
  },
  validateAuthCode: (referrer: string, authCode: string) => {
    return axios.post(VALIDATE_AUTH_CODE_URL, { referrer, authCode });
  },
  entrataUserSignUp: (credentials: {
    username: string;
    password: string;
    entrataUserId: string;
    clientId: number;
  }) => {
    return axios.post(ENTRATA_SIGNUP_URL, credentials);
  },
  getStrategySpecs: (type: string) => {
    const params = new URLSearchParams();
    if (type === 'newLease') {
      params.append('type', 'NewLease.Strategy');
    } else {
      params.append('type', 'Renewal.Strategy');
    }

    let url = `${SETTINGS_STRATEGY_SPECS}?${params.toString()}`;
    return fetchWithRetry(url);
  },
  getMasterSettings: (data: any) => {
    const params = new URLSearchParams();

    if (data.hasOwnProperty('key')) {
      params.append('key', data.propertyCode);
    }
    if (data.hasOwnProperty('propertyCode')) {
      params.append('propertyCode', data.propertyCode);
    }
    let url = `${MASTER_SETTINGS}?${params.toString()}`;
    return fetchWithRetry(url);
  },
  getPropertiesSettings: (data: any) => {
    const params = new URLSearchParams();
    /*
    if (data.hasOwnProperty('key')) {
      params.append('key', data.propertyCode);
    }
    if (data.hasOwnProperty('propertyCode')) {
      params.append('propertyCode', data.propertyCode);
    }
    */
    let url = `${PROPERTIES_SETTINGS}/${params.toString()}`;
    return fetchWithRetry(url);
  },
  getSFRProperties: () => {
    return fetchWithRetry(GET_SFR_PROPERTIES_URL);
  },
  getUsers: () => {
    return fetchWithRetry(GET_USERS);
  },
  occupancyReport: (length: number) => {
    let params = new URLSearchParams();
    params.append('length', length.toString());

    return fetchWithRetry(`${OCCUPANCY_REPORT}?${params.toString()}`);
  },
  getLeaseReport: (data: any) => {
    const url = `${GET_LEASE_REPORT_DATA}?${getReportParams(data).toString()}`;
    return fetchWithRetry(url);
  },
  getRenewalReport: (data: any) => {
    const url = `${GET_RENEWAL_REPORT_DATA}?${getReportParams(
      data
    ).toString()}`;
    return fetchWithRetry(url);
  },
  getGeneralReport: (data: any) => {
    const url = `${GET_GENERAL_REPORT_DATA}?${getReportParams(
      data
    ).toString()}`;
    return fetchWithRetry(url);
  },

  updateMasterSettings: (data: any) => {
    return axios.put(`${MASTER_SETTINGS}`, data);
  },
  updateUser: (userID: any, data: any) => {
    return axios.put(`${GET_USERS}/` + userID, data);
  },
  resetSettingsForProperty: (propertyCode: any) => {
    return axios.delete(`${MASTER_SETTINGS}/` + propertyCode + '/reset');
  },

  fetchFiles: () => {
    return fetchWithRetry(`${DOWNLOADS}`);
  },
  deleteFile: (id: any) => {
    return axios.delete(`${DOWNLOADS}/${id}`);
  },
  generateFile: (id: any, clientID: any, filters: any, reportType: string) => {
    //clientId: clientID,
    let data = { reportParameters: filters, reportType };
    return axios.post(`${DOWNLOADS}/${id}`, data);
  },
  sendOnEmail: (id: any, clientID: any, filters: any, email: any) => {
    //clientId: clientID,
    let data = { reportParameters: filters, toEmail: email };
    return axios.post(`${DOWNLOADS}/${id}`, data);
  },

  fetchFile: (id: any) => {
    return fetchWithRetry(`${DOWNLOADS}/${id}`);
  },
  fetchFileDownload: (id: any) => {
    return fetchWithRetry(`${DOWNLOADS}/${id}/download`);
  },
  resendReport: (id: any, email: any) => {
    let data = { toEmail: email };
    return axios.post(`${DOWNLOADS}/${id}/email`, data);
  },
  fetchFileContent: (url: any) => {
    return fetchWithRetry(url);
  },
  updateStrategyByMarket: (data: {
    market: string;
    strategy: string;
    type: string;
    parameterValue: string;
  }) => {
    return axios.put(UPDATE_STRATEGY_BY_MARKET_URL, data);
  },
  fetchScheduledReports: () => {
    return fetchWithRetry(`${SCHEDULER_REQUEST}`);
  },
  updateScheduledReport: (
    id: number | null,
    itemToSend: {
      emailAddress: string;
      reportId: string;
      frequency: string;
      isActive: boolean;
    }
  ) => {
    if (id === null || id === undefined) {
      return axios.post(`${SCHEDULER_REQUEST}`, itemToSend);
    } else {
      return axios.put(`${SCHEDULER_REQUEST}/` + id, itemToSend);
    }
  },
  getSchedulerJobs: (startDate: Date, endDate: Date) => {
    return fetchWithRetry(
      `${GET_SCHEDULED_JOBS_URL}?startDate=${format(
        startDate,
        'yyyy-MM-dd'
      )}&endDate=${format(endDate, 'yyyy-MM-dd')}`
    );
  },
  getTaskExecutionStatus: (executionId: string) => {
    return fetchWithRetry(GET_TASK_EXECUTION_STATUS_URL(executionId));
  },
  getUnitPriceMatrix: (unitDetailId: number) => {
    return fetchWithRetry(`${GET_UNIT_PRICE_MATRIX}/${unitDetailId}`);
  },

  updateUnitOffers: (offers: any) => {
    return axios.put(`${UPDATE_UNIT_OFFERS}`, offers);
  },
  getSetting: (key: string) => {
    return fetchWithRetry(`${GET_SETTING}/${key}`);
  },
  getExposureRentTrendReport: (unittype: string, uptoMonths: number) => {
    return axios.post(EXPOSURE_RENT_TREND_REPORT, {
      unittype: unittype,
      uptoDays: uptoMonths,
    });
  },
  uploadToPMS: (
    type: 'renewal' | 'newLease',
    filters: {
      propertyCode: string | null;
      unitType?: string | null;
      bedrooms: number | null;
    }
  ) => {
    return axios.post(`${UPLOAD_TO_PMS_URL}${type}/upload`, filters);
  },
  checkOfferGenerationStatus: (id: string) => {
    return fetchWithRetry(`${GET_TASK_EXECUTION_STATUS}/${id}`);
  },
  shiftPriceMatrice: (data: {
    propertyCode: string;
    unitType: string;
    shiftAmount: number;
    shiftBy: string;
  }) => {
    return axios.put(`${SHIFT_PRICE_MATRICES}`, data);
  },
  generateRenewalOffers: (data: any) => {
    return axios.post(GENERATE_RENEWAL_OFFERS, data);
  },
  generateNewLeaseOffers: (data: any) => {
    return axios.post(GENERATE_NEW_LEASE_OFFERS, data);
  },
  fetchMarketRentReports: () => {
    return axios.get(GET_MARKET_RENT_REPORTS);
  },
  updateMarketRentReports: (data: any) => {
    return axios.post(UPDATE_MARKET_RENT_REPORTS, data);
  },
  checkMarketRentOfferGenerationStatus: (clientId: number) => {
    return axios.get(
      `${CHECK_MARKET_RENT_OFFER_GENERATION_STATUS}/${clientId}`
    );
  },
  bulkApproveRenewals: (data: any) => {
    return axios.put(`${BULK_APPROVE_RENEWALS}`, data);
  },
  bulkApproveUnitTypeOffers: (data: any) => {
    return axios.put(`${BULK_APPROVE_UNITTYPE_OFFERS}`, data);
  },
  bulkApproveUnitLevelOffers: (data: any) => {
    return axios.put(`${BULK_APPROVE_UNITLEVEL_OFFERS}`, data);
  },
  getRenewalUploadOfferLogs: (offerCycle: string) => {
    return axios.get(`${GET_RENEWAL_UPLOAD_OFFER_LOGS}`, {
      params: { offerCycle },
    });
  },
  getNewLeaseUploadOfferLogs: (offerCycle: string) => {
    return axios.get(`${GET_NEW_LEASE_UPLOAD_OFFER_LOGS}`, {
      params: { offerCycle },
    });
  },
  getFilterOptions: () => {
    return axios.get(GET_FILTER_OPTIONS);
  },
  getFloorplanData: (data: any) => {
    let urlParams = new URLSearchParams();
    const { beds, propertyCode, unitType, ...rest } = data;

    if (beds && beds.toString() !== ALL) {
      urlParams.append('beds', beds);
    }
    if (propertyCode && propertyCode.id !== ALL)
      urlParams.append('propertyCode', propertyCode.id);
    if (unitType && unitType.toString() !== ALL)
      urlParams.append('unitType', unitType);

    Object.entries(rest).forEach(([key, value]) => {
      if (value) urlParams.append(key, value as string);
    });

    return axios.get(`${GET_FLOORPLAN_DATA}?${urlParams.toString()}`);
  },
  getUnitsData: (data: {
    propertyCode: string | null;
    unitType: string | null;
    beds: string | undefined | null;
    offerStatus: string | undefined | null;
    unitStatus: string | undefined | null;
  }) => {
    const { propertyCode, unitType, ...rest } = data;

    const body = {
      unitType,
      propertyCode,
      offerStatus: rest.offerStatus,
      beds: rest.beds === ALL ? null : rest.beds,
      unitStatus: rest.unitStatus === ALL ? null : rest.unitStatus,
    };

    return axios.post(GET_UNITS_DATA, body);
  },
  getStatsData: (filters: any) => {
    const params = new URLSearchParams();
    params.append('startDate', filters.startDate);
    params.append('length', filters.length);
    filters.bedRoom && params.append('bedRoom', filters.bedRoom);
    filters.propertyCode && params.append('propertyCode', filters.propertyCode);
    filters.unitType && params.append('unitType', filters.unitType);

    const url = `${GET_STATS_DATA}?${params.toString()}`;

    return axios.get(url);
  },
  unifiedApproveOffer: (propertyCode: string, unitType: string) => {
    return axios.post(UNIFIED_APPROVE_OFFER_URL, {
      propertyCode,
      unitType,
    });
  },
  unifiedExcludeOffer: (propertyCode: string, unitType: string) => {
    return axios.post(UNIFIED_EXCLUDE_OFFER_URL, {
      propertyCode,
      unitType,
    });
  },
  getFlagDetails: (id: string) => {
    return axios.get(`${GET_FLAG_DETAILS_URL}/${id}`);
  },
  addFlagComment: (data: any) => {
    return axios.post(ADD_FLAG_COMMENT_URL, data);
  },
  resolveFlagItem: (id: string) => {
    return axios.put(`${RESOLVE_FLAG_ITEM_URL}/${id}`);
  },
  shiftAllOffers: (data: any) => {
    return axios.put(`${SHIFT_ALL_OFFERS_URL}`, data);
  },
  approveAll: (data: any) => {
    return axios.post(`${APPROVE_ALL_URL}`, data);
  },
  getPriceMatrices2: (data: any) => {
    return axios.post(GET_PRICE_MATRICES_UNIFIED, data);
  },
  getPropertyPortfolioData: () => {
    return axios.get(GET_PROPERTY_PORTFOLIO_DATA);
  },
};

export default api;
